import { render, staticRenderFns } from "./ColumnTransactionStatusTefGsurf.vue?vue&type=template&id=261301b5&scoped=true"
import script from "./ColumnTransactionStatusTefGsurf.vue?vue&type=script&lang=js"
export * from "./ColumnTransactionStatusTefGsurf.vue?vue&type=script&lang=js"
import style0 from "./ColumnTransactionStatusTefGsurf.vue?vue&type=style&index=0&id=261301b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261301b5",
  null
  
)

export default component.exports